import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { computed } from 'vue';
import filters from '@/filters';

const GET_REFERRAL_REWARD_QUERY = gql`
  query getReferralReward {
    referralReward {
      amount
      currency
    }
  }
`;

export const useReferralReward = () => {
  const { result, loading } = useQuery(
    GET_REFERRAL_REWARD_QUERY,
    {},
    {
      fetchPolicy: 'cache-first',
    },
  );

  const referralReward = computed(() => result.value?.referralReward);

  const formattedAmount = computed(() => {
    if (!referralReward.value) return '';
    return filters.currency(
      referralReward.value.amount,
      referralReward.value.currency,
    );
  });

  return {
    referralReward,
    formattedAmount,
    loading,
  };
};
